module.exports = __webpack_public_path__ + "img/7.0d893a33.png";